import React from 'react'

export default function Form({ children, height, handleSubmit }) {
    return (
        // container.clientWidth  = 384 / 4 = 96
        <form onSubmit={handleSubmit}
            className={`bg-gray-800 p-8 mt-4 rounded-lg w-96 mx-4 ${height}`}>
            {children}
        </form>
    )
}
